/* unplugin-vue-components disabled */import script from "./PocketPropsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PocketPropsCard.vue?vue&type=script&setup=true&lang=js"

import "./PocketPropsCard.vue?vue&type=style&index=0&id=45779acc&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45779acc"]])

export default __exports__